import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  apiError,
  getAreaManagers,
  areaManagerListSuccessful,
  areaManagerAddSuccessful,
  managerListSuccessful,
} from "./areaManagerSlice";
import { Modal } from "antd";
import { RiCheckboxCircleLine, RiAlertLine } from "react-icons/ri";
import { postAdd, getParamsList, postEdit, postDelete } from "../../../helpers/Helper";

function* fetchAreaManagerList({ payload }) {
  var params = {};
  for (const k in payload) {
    if (Object.hasOwnProperty.call(payload, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = payload.sortOrder + payload.currentSort;
      } else if (payload[k] != "" && k != null && k != "no_of_pages") {
        params[k] = payload[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/area-managers/", params);
    yield put(areaManagerListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddAreaManager({ payload }) {
  try {
    const obj = { name: payload.name, manager_id: payload.manager_id };
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/area-managers/", obj);
      if (response.status === 201) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Area Manager Added Successfully!</p>,
        });
        yield put(getAreaManagers({ page: 1, search: "", page_size: 10 }));
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to add Area Manager!</p>,
        });
      }
    } else {
      const response = yield call(postEdit, "/masters/area-managers/" + payload.id, obj);
      if (response.status === 200) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Area Manager Updated Successfully!</p>,
        });
        yield put(getAreaManagers({ page: 1, search: "", page_size: 10 }));
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to update Area Manager!</p>,
        });
      }
    }
    yield put(areaManagerAddSuccessful());
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>,
    });
    yield put(apiError(error));
  }
}

function* DeleteAreaManager({ payload }) {
  try {
    const response = yield call(postDelete, "/masters/area-managers/" + payload);
    if (response.status === 204) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Area Manager deleted!</p>,
      });
      yield put(getAreaManagers({ page: 1, search: "", page_size: 10 }));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchManagerList({ payload }) {
  try {
    const response = yield call(getParamsList, "/masters/managers/", payload);
    yield put(managerListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AreaManagerSaga() {
  yield all([
    fork(function* () { yield takeEvery("areaManager/getAreaManagers", fetchAreaManagerList); }),
    fork(function* () { yield takeEvery("areaManager/areaManagerAdd", AddAreaManager); }),
    fork(function* () { yield takeEvery("areaManager/areaManagerDelete", DeleteAreaManager); }),
    fork(function* () { yield takeEvery("areaManager/getManagerList", fetchManagerList); }),
  ]);
}

export default AreaManagerSaga;
